/*

Library imports from external API's

*/
import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

// Component imports from external API
import _ from "underscore";

//Home brewed Components
import ModalAddToCartAndQuote from "../../Common/ModalComponents/ModalAddToCartAndQuote.jsx";

// Misc
// Misc
import { ADD_TO_CART_MODAL } from "../../../actions/assays.js"; // dispatch constants for modals
import { processOrderObject, doesNotExist } from "../../../util/format.js";
/*


  Component: Add to Cart and Quote Button Component
  SubComponents: ModalAddToCartAndQuote, AddToCartButton and AddToQuoteButton.
  Usage: For ModalAddToCartAndQuote populating cart and quote buttons
*/
export class AddToCartAndQuoteButton extends React.Component {
  /*
    Initialize the constructor with state.
    properties in state:
      * assay commercial id : Used to order assay. Default value is false (if empty).
      * showModal: Flag for the Modal. Default value is false(Modal shouldn't be visible unless clicked).
      * isQuote: Used to decide whether the Modal should be a Cart or Quote. Default behavior is cart.
      * CartClicked: Flag used to keep track of user add to cart click button.
      * QuoteClicked: Flag used to keep track of user add to cart click button.

  */

  static propTypes = {
    actions: PropTypes.object,
    row: PropTypes.object,
    assayDetail: PropTypes.object,
    uniqueIdentifier: PropTypes.number,
    cartLink: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      assayCommercialId: false,
      showModal: false,
      isQuote: false,
      cartClicked: false,
      quoteClicked: false,
      uniqueRowId: false,
    }; // Intial State of the Component.
    this.handleCartClicked = this.handleCartClicked.bind(this); // Binding the method to the current context
    this.handleQuoteClicked = this.handleQuoteClicked.bind(this); // Binding the method to the current context
  }

  /*

    Handling the user click on the Add to Cart button in the Assay Row.
    This toggles the `cartClicked` flag in state and displays `Check out Cart`.
  */
  handleCartClicked() {
    this.setState({ cartClicked: !this.state.cartClicked });
  }

  /*

    * Handling the user click on the Add to Quote button in the Assay Row.
    * This toggles the `quoteClicked` flag in state and displays `Check out Quote`.
  */
  handleQuoteClicked() {
    this.setState({ quoteClicked: !this.state.quoteClicked });
  }

  /*

    * Request the data for the Cart Modal by dispatching an action `fetchAssayDetail`.
    * set the flag to display the cart Modal and Update assayCommercialId
    * which will be used by the Modal
  */
  dispatchActionForCartButton() {
    const {
      actions,
      row,
      row: { assayId, uniqueRowId },
    } = this.props;

    actions.fetchAssayDetail(assayId, uniqueRowId);
    this.setState({
      showModal: true,
      assayCommercialId: assayId,
      uniqueRowId: uniqueRowId,
      isQuote: false,
    });
  }

  /*

    * Request the data for the Quote Modal by dispatching an action `fetchAssayDetail`.
    * set the flag to display the quote Modal `(isQuote:true)` and Update assayCommercialId
    * which will be used by the Modal
  */
  dispatchActionForQuoteButton() {
    const {
      actions,
      row: { assayId, uniqueRowId },
    } = this.props;
    actions.fetchAssayDetail(assayId, uniqueRowId);
    this.setState({
      showModal: true,
      assayCommercialId: assayId,
      isQuote: true,
    });
  }

  /*
   * Generating ordering info for its respective commercial ID.
   * This method returns the ordering info for commeracial ID in component state.
   * Util function for it.
   */
  generatingOrderingInfo() {
    const { assayCommercialId } = this.state;
    const { assayDetail } = this.props;

    const detailCommercialId =
      (assayDetail &&
        assayDetail.data &&
        assayDetail.data.data &&
        assayDetail.data.data.id) ||
      "";

    const targetType =
      (assayDetail &&
        !_.isEmpty(assayDetail) &&
        assayDetail.data &&
        !_.isEmpty(assayDetail.data) &&
        assayDetail.data.data &&
        !_.isEmpty(assayDetail.data.data) &&
        assayDetail.data.data.target &&
        !_.isEmpty(assayDetail.data.data.target) &&
        !_.isEmpty(assayDetail.data.data.target.targetType) &&
        assayDetail.data.data.target.targetType) ||
      false;

    const orderingInfo =
      (assayCommercialId === detailCommercialId && // If commercial id is same as in assay detail
        assayDetail &&
        assayDetail.data &&
        assayDetail.data.data &&
        assayDetail.data.data.orderingInfo) ||
      {};

    const newOrderingInfo =
      (!_.isEmpty(orderingInfo) && {
        ...orderingInfo,
        skuMap: processOrderObject(orderingInfo.skuMap),
        targetType: targetType,
      }) ||
      {};

    return newOrderingInfo;
  }

  componentDidUpdate() {
    const { showModal } = this.state;
    const {
      actions,
      uniqueRowId,
      row: { createdAt },
    } = this.props;
    const orderingInfo = this.generatingOrderingInfo(); // get order information.

    if (showModal && orderingInfo) {
      // Dispatch action to open `Add to cart` modal if the orderingInfo and showModal is true.
      actions.setAssayModalType(ADD_TO_CART_MODAL, uniqueRowId);

      this.setState({ showModal: false }); // Reverting to default state as it already triggered the modal.
    }
  }

  render() {
    const {
      actions,
      row,
      row: { createdAt, assayDesignId },
      cartLink,
      cartAssayUniqueId,
      quoteAssayUniqueId,
      assayDetail,
      uniqueRowId,
      uniqueAssayRowId,
    } = this.props;
    const { isQuote } = this.state;
    /*
     * Add to Cart Button base Component used in Add to Cart and Quote Button.
     */
    const AddToCartButton = () => (
      <button
        onClick={(e) => {
          e.preventDefault();
          this.dispatchActionForCartButton();
        }}
        className="rounded solid small"
      >
        Add to Cart
      </button>
    );
    /*
     * Add to Quote Button base Component used in Add to Cart and Quote Button.
     */
    const AddToQuoteButton = () => {
      return (
        <a
          href=""
          className="add-to-quote"
          onClick={(e) => {
            e.preventDefault();
            this.dispatchActionForQuoteButton();
          }}
        >
          Add to Quote
        </a>
      );
    };
    /*

     * Check out cart Button base Component used in Add to Cart and Quote Button.
    */
    const CheckOutCart = (cartLink) => {
      return (
        <div>
          <a className="check-cart" href={cartLink.cartLink}>
            Check Out
          </a>
        </div>
      );
    };
    /*

     * Check out quote Button base Component used in Add to Cart and Quote Button.
    */
    const CheckOutQuote = (cartLink) => (
      <div>
        <a className="check-quote" href={`${cartLink.cartLink}#fragment-2`}>
          [Get Quote]
        </a>
      </div>
    );
    // Get the Order Info
    const orderingInfo = this.generatingOrderingInfo();
    return (
      <>
        {/* Toggle cart options*/}

        {_.contains(cartAssayUniqueId, uniqueRowId) &&
        cartAssayUniqueId &&
        cartAssayUniqueId.includes(uniqueRowId) ? (
          <CheckOutCart cartLink={cartLink} />
        ) : (
          <AddToCartButton />
        )}

        {/* Toggle quote options*/}
        {_.contains(quoteAssayUniqueId, uniqueRowId) &&
        quoteAssayUniqueId &&
        quoteAssayUniqueId.includes(uniqueRowId) ? (
          <CheckOutQuote cartLink={cartLink} />
        ) : (
          <AddToQuoteButton />
        )}
        {/*Modal for add to cart and quote*/}
        {uniqueAssayRowId === uniqueRowId && (
          <ModalAddToCartAndQuote
            orderingInfo={orderingInfo}
            actions={actions}
            uniqueRowId={uniqueRowId}
            isQuote={isQuote}
            handleCartClicked={this.handleCartClicked}
            handleQuoteClicked={this.handleQuoteClicked}
          />
        )}
      </>
    );
  }
}

// State to props
const stateToProps = (state) => ({
  cartLink:
    (state &&
      !_.isEmpty(state.addToCart) &&
      !_.isEmpty(state.addToCart.assayCartHtml) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0]) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0].props) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0].props.children) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0].props.children[1]) &&
      !_.isEmpty(state.addToCart.assayCartHtml[0].props.children[1].props) &&
      !_.isEmpty(
        state.addToCart.assayCartHtml[0].props.children[1].props.children
      ) &&
      !_.isEmpty(
        state.addToCart.assayCartHtml[0].props.children[1].props.children[0]
      ) &&
      !_.isEmpty(
        state.addToCart.assayCartHtml[0].props.children[1].props.children[0]
          .props
      ) &&
      state.addToCart.assayCartHtml[0].props.children[1].props.children[0].props
        .href) ||
    "",
  uniqueAssayRowId: state.assays.modalInfo.uniqueAssayRowId || "",
  cartAssayUniqueId: state.addToCart.cartAssayUniqueId || "",
  quoteAssayUniqueId: state.addToCart.quoteAssayUniqueId || "",
  assayDetail: (state.assays && state.assays.detail) || {},
});

// Connect it to the Redux State
export default AddToCartAndQuoteButton = connect(
  stateToProps,
  {} // empty dispatch
)(AddToCartAndQuoteButton);
